export const SUBHEADING_ARRAY = [
  'Pay the outstanding balance for this job securely using Open Banking, and stay safe in the knowledge that ',
  'your money is secure until the job is complete. ',
  'Once the job is complete, we will ask you to confirm the work is finished before we release the money to $partner',
];
